import Vue from "vue";

Vue.component("party-threshold-notifications", {
	props: ["partyId"],
	data() {
		return {
			loading: false,
			thresholdNotifications: [],
			showNationalCurrencyThresholdsModal: false,
			nationalCurrencyThresholdsLoading: false,
			nationalCurrencyThresholds: [],
			nationalCurrencyThresholdsTitle: null,
			labels: {
				annex: window.labels.annex,
				thresholdsFor: window.labels.thresholdsFor,
				validityPeriod: window.labels.validityPeriod,
				appliesTo: window.labels.appliesTo,
				valueInLocalCurrency: window.labels.valueInLocalCurrency,
				reportedExchangeRate: window.labels.reportedExchangeRate,
			}
		};
	},
	methods: {
		getByPartyId: function() {
			this.loading = true;
			this.$services.thresholdNotificationsService.getByPartyId({
				partyId: this.partyId,
				language: window.currentLanguage
			})
				.then((data) => {
					this.loading = false;
					this.thresholdNotifications = data;
				});
		},
		showNationalCurrencyThresholds: function(thresholdNotificationId) {
			this.showNationalCurrencyThresholdsModal = true;
			this.nationalCurrencyThresholdsLoading = true;
			this.$services.nationalCurrencyThresholdsService.getByThresholdNotificationId({
				thresholdNotificationId: thresholdNotificationId,
				language: window.currentLanguage
			})
				.then((data) => {
					this.nationalCurrencyThresholdsLoading = false;
					this.nationalCurrencyThresholdsTitle = data.title,
					this.nationalCurrencyThresholds = data.items;
				});
		},
	},
	mounted() {
		this.getByPartyId();
	},
	computed: {
		noInformationAvailable: function() {
			return window.labels.noInformationAvailable;
		}
	},
	template: `
	<div>
		<loading v-if="loading"></loading>
		<template v-else>
			<b-table :data="thresholdNotifications" detail-key="id" class="party-threshold-notifications-table">
				<b-table-column>
					<template v-slot="props">
						<a href="javascript:void(0)" @click="showNationalCurrencyThresholds(props.row.id)" class="party-notification-date-range">
							{{ props.row.validityDateString }}
						</a>
					</template>
				</b-table-column>
				<b-table-column cell-class="has-text-right">
					<template v-slot="props">
						<span v-html="props.row.documentSymbolLink"></span>
					</template>
				</b-table-column>
			</b-table>
			<p v-if="!loading && thresholdNotifications.length === 0" class="has-text-centered pb-5">{{ noInformationAvailable }}</p>
		</template>

		<b-modal
			v-model="showNationalCurrencyThresholdsModal"
			has-modal-card
			trap-focus
			width="auto"
			:destroy-on-hide="true"
			scroll="keep"
			aria-role="dialog"
			aria-modal>
			<template #default="props">
				<section class="card">
					<header class="card-header">
						<h3 class="card-header-title">{{ nationalCurrencyThresholdsTitle }}</h3>
					</header>
					<div class="card-content">
						<div class="content" style="overflow-y: auto;">
							<div style="max-width: 1152px;">
								<loading v-if="nationalCurrencyThresholdsLoading"></loading>
								<template v-else>									
									<b-table
										detail-key="id"
										:data="nationalCurrencyThresholds"
										:sticky-header="true"
										height="calc(70vh) !important"
										class="national-currency-thresholds-table"
										striped
										hoverable>
										<b-table-column :label="labels.annex" class="national-currency-thresholds-table-annex-number">
											<template v-slot="props">
												{{ props.row.annexNumber }}
											</template>
										</b-table-column>
										<b-table-column :label="labels.thresholdsFor" class="national-currency-thresholds-table-threshold-for" >
											<template v-slot="props">
												{{ props.row.thresholdFor }}
											</template>
										</b-table-column>
										<b-table-column :label="labels.appliesTo">
											<template v-slot="props">
												{{ props.row.appliesTo }}
											</template>
										</b-table-column>
										<b-table-column label="SDR" numeric class="national-currency-thresholds-table-sdr">											
											<template v-slot="props">
												{{ props.row.sdrValue | thresholdValue }}
											</template>
										</b-table-column>
										<b-table-column :label="labels.valueInLocalCurrency" numeric class="national-currency-thresholds-table-currency-value">
											<template v-slot="props">
												{{ props.row.currencyValue | thresholdValue }} {{ props.row.currencyCode }}
											</template>
										</b-table-column>
										<b-table-column :label="labels.reportedExchangeRate" numeric class="national-currency-thresholds-table-reported-exchange-rate">											
											<template v-slot="props">
												<template v-if="props.row.reportedExchangeRate > 0">{{ props.row.reportedExchangeRate | exchangeRateValue }}</template>
												<template v-else>
													<div class="has-text-centered">-</div>
												</template>
											</template>
										</b-table-column>
									</b-table>
								</template>
							</div>
						</div>
					</div>
				</section>
			</template>
		</b-modal>	
	</div>
	`
});